/* eslint-disable max-len */
import React from "react"
import formatMobileNumber from "../../../CommonMethods/FormatMobileNumber"
import { useState } from "react"
import { motion } from "framer-motion"
import AnimatedButton from "../../../components/Animation/AnimatedButton"
import { useRef } from "react"
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from "../../../CommonMethods/OutsideClick"


export default function SubDivTable({viewOrganizationDetails,edit,onEditButtonClick,hoverProperties,setHoverProperties,confirmation,viewOrg,id,handleSearchClose}){
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const [searchParams,setSearchParams]=useSearchParams({})
    const navigate = useNavigate();


    const selectedRef = useRef();

    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
       
    }
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });   
    
    return(
        <div className={`overflow-x-auto scrollBar-hidden mt-3.5 ${ (viewOrg && selectedIndex!==null) && 
                selectedIndex ===0 && viewOrganizationDetails?.sub_divisions?.length<=4 && 
                viewOrganizationDetails?.sub_divisions?.length < 4 ? 'pb-[180px]' 
            : selectedIndex === 0 && viewOrganizationDetails?.sub_divisions?.length === 4 ? 'pb-[50px]' 
                : selectedIndex === 1 && viewOrganizationDetails?.sub_divisions?.length < 4 ? 'pb-[180px]' 
                    : selectedIndex === 2 && viewOrganizationDetails?.sub_divisions?.length < 4 ? 'pb-[180px]' 
                        : selectedIndex === 2 && viewOrganizationDetails?.sub_divisions?.length === 4 ? 'pb-[150px]' 
                            : selectedIndex === 1 && viewOrganizationDetails?.sub_divisions?.length === 4 ? 'pb-[80px]' 
                                : selectedIndex === 3 && viewOrganizationDetails?.sub_divisions?.length < 4 ? 'pb-[130px]' 
                                    : selectedIndex === 2 && viewOrganizationDetails?.sub_divisions?.length >= 4 ? 'pb-[80px]'
                                        : selectedIndex === 1 && viewOrganizationDetails?.sub_divisions?.length >= 4 ? 'pb-[40px]' 
                                            : 'pb-3'} `}>
            <table aria-label="Outside Table" className="w-full table-auto">
                <thead>
                    <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm z-10">
                        <th id="id" className="px-3 py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID
                            </span>
                        </th>
                        <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Sub Division 
                            </span>
                        </th>
                        <th id="contact" className="px-3 py-2 min-w-[180px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Contact
                            </span>
                        </th>
                        <th id='email_address' className="px-3 py-2 min-w-[180px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address
                            </span>
                        </th>
                        <th id='main_number' className="px-3 py-2 min-w-[180px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Main Number
                            </span>
                        </th>
                        <th id='mobile_number' className="px-3 py-2 min-w-[180px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                            </span>
                        </th>
                        <th id='reading_days_count' className="px-3 py-2 min-w-[100px]">
                            <span className="flex items-center justify-start text-start text-sm font-normal text-[#000000]">Reading Days Count
                            </span>
                        </th>
                        <th id="vital_time_period" className="px-3 py-2 min-w-[145px]">
                            <span className="flex items-center justify-end text-end text-sm font-normal text-[#000000]">Time Period
                            </span>
                        </th>
                        <th id="qualified_contact_count" className="px-3 py-2 min-w-[118px]">
                            <span className="flex items-center justify-end text-start text-sm font-normal text-[#000000]">Qualified Contact Count
                            </span>
                        </th>
                        <th id="minimum_minutes" className="px-3 py-2 min-w-[80px]">
                            <span className="flex items-center justify-start text-start text-sm font-normal text-[#000000]">Minimum Minutes
                            </span>
                        </th>
                        <th id='wellness_time_period' className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] min-w-[145px]">
                            <span className="flex items-center justify-end text-end text-sm font-normal text-[#000000]">Time Period
                            </span>
                        </th>
                        {
                            (edit!==undefined || viewOrg) &&<th id='action' className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] min-w-[100px] sticky right-0">
                                <span className="flex items-center justify-center text-end text-sm font-normal text-[#000000]">Actions
                                </span>
                            </th>
                        }
                        
                    </tr>
                </thead>
                <tbody>
                    {viewOrganizationDetails?.sub_divisions?.map((item,index) => (
                        <tr key={index} className="bg-[#fff] hover:bg-[#F8EEF1] table-tr">
                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{item?.subdivision_id || '-'}</td>
                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{item?.name || '-'}</td>
                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{item?.point_of_contact_person?.name || '-'}</td>
                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{item?.point_of_contact_person?.email_address || '-'}</td>
                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">
                                {item?.point_of_contact_person?.poc_main_country_code && item?.point_of_contact_person?.main_number
                                    ? `${item.point_of_contact_person.poc_main_country_code}\t${formatMobileNumber(item.point_of_contact_person.main_number)}`
                                    : '-'
                                }                                                            
                            </td>
                            <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">
                                {item?.point_of_contact_person?.poc_mobile_country_code && item?.point_of_contact_person?.mobile_number
                                    ? `${item.point_of_contact_person.poc_mobile_country_code}\t${formatMobileNumber(item.point_of_contact_person.mobile_number)}`
                                    : '-'
                                }                                                            
                            </td>
                            <td className="px-3 py-2 text-sm text-end font-normal text-[#031624]">{item?.vital_collection_timing?.number_of_readings || '-'}</td>
                            <td className="px-3 py-2 text-sm text-end font-normal text-[#031624]">
                                {item?.vital_collection_timing?.number_of_time_periods && item?.vital_collection_timing?.time_period
                                    ? `${item.vital_collection_timing.number_of_time_periods} ${item.vital_collection_timing.time_period}`
                                    : '-'
                                }
                            </td>
                            <td className="px-3 py-2 text-sm text-end font-normal text-[#031624]">10</td>
                            <td className="px-3 py-2 text-sm text-end font-normal text-[#031624]">{item?.wellness_timing?.number_of_minutes ||  '-'}</td>
                            <td className="px-3 py-2 text-sm text-end font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px]">
                                {item?.wellness_timing?.number_of_time_periods && item?.wellness_timing?.time_period
                                    ? `${item.wellness_timing.number_of_time_periods} ${item.wellness_timing.time_period}`
                                    : '-'
                                }
                            </td>
                            {edit!==undefined&&
                            
                                <td onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className=" px-8 py-2 text-sm text-end font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] min-w-[50px] last-td sticky right-0 bg-white">
                                    
                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                        <motion.div
                                            initial={{ opacity: 1, x: 0,y:0 }}
                                            animate={{ opacity: 1, x: -20 ,y:0}}
                                            transition={{ delay: 0.2, duration: 0.5 }}
                                            exit={{ opacity: 0.5 }}
                                            className=''
                                        >
                                            <button 
                                                onClick={()=>{onEditButtonClick(index)}}  
                                            > 
                                                <img src="/images/edit_icon.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                        </motion.div>
                                    
                                    </>:<button 
                                        onClick={()=>{onEditButtonClick(index)}} 
                                        id={index + 'edit'} 
                                    > 
                                        <img src="/images/edit_icon.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}
                                    
                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                        <motion.div
                                            initial={{ opacity: 0, x: 0,y:0 }}
                                            animate={{ opacity: 1, x: 0 ,y:0}}
                                            transition={{ delay: 0.2, duration: 0.5 }}
                                            exit={{ opacity: 0.5 }}
                                            className=''
                                        >
                                        
                                            <div className='relative ml-2 cursor-pointer mt-[-20px]' onClick={()=>{onEditButtonClick(index)}} >
                                        
                                                <p className="text-sm  font-normal text-[#972E4C] ">Edit</p>
                                       
                                            </div>
                                        </motion.div>
                                   
                                    }
                                    
                                </td>
                            }
                            {viewOrg && 
                                <td className={`px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click last-td bg-white`}>
                                    <div  className="relative flex items-center justify-center prevent-click" data-te-dropdown-ref>
                                        <button type='button' className="text-white transition duration-150 ease-in-out w-[40px] h-[34px] rounded-[50%] flex justify-center items-center prevent-click action-button"
                                            id={item?.subdivision_id}
                                            onClick={() =>handelActionButton(index) }>
                                            <img loading="lazy" decoding="async" src="/images/3_dots_list.svg" alt="icon" className="prevent-click" />
                                        </button>
                                        {selectedIndex===index&& <ul  ref={selectedRef}  className={`border border-[#C2DCEF] p-2.5 absolute z-[99] float-left m-0 right-[88px] min-w-[135px] dropdown-menu
                                            ${index<3 ? 'top-[0px]' : 'bottom-[-8px]'}  list-none rounded-lg  bg-white bg-clip-padding text-left [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref >
                                        
                                            <li>
                                                <AnimatedButton
                                                    handleClick={(e)=>{onEditButtonClick(index)}}
                                                    buttonName={"Edit"}
                                                    className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 mb-2 text-base font-normal text-[#000000] prevent-click" />
                                            </li>
                                            <li>
                                                <button type="button"
                                                    onClick={()=>{handleSearchClose(),       
                                                    navigate(`/manage-organizations/monitor-user-list/${item?.subdivision_id}`);
                                                    }}
                                                    className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] transition-all hover:scale-[1.02] px-[2px] rounded py-1 mb-2 text-base font-normal text-[#000000] prevent-click">
                                                    View Monitor Users
                                                </button>
                                            </li>   
                                            <li>
                                                <button type="button"
                                                    onClick={()=>{handleSearchClose(),       
                                                    navigate(`/manage-organizations/corporate-user-list/${item?.subdivision_id}`);
                                                    }}
                                                    className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] transition-all hover:scale-[1.02] px-[2px] rounded py-1 mb-2 text-base font-normal text-[#000000] prevent-click">
                                                    View Corporate Users
                                                </button>
                                            </li> 
                                            <li>
                                                <button type="button"
                                                    onClick={()=>{handleSearchClose(),       
                                                    navigate(`/manage-organizations/patient-list/${item?.subdivision_id}`);
                                                    }}
                                                    className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] transition-all hover:scale-[1.02] px-[2px] rounded py-1 mb-2 text-base font-normal text-[#000000] prevent-click">
                                                    View Patients
                                                </button>
                                            </li>
                                            <li>
                                                <button type="button"
                                                    onClick={()=>{handleSearchClose(),       
                                                    navigate(`/manage-organizations/providers-list/${item?.subdivision_id}`);
                                                    }}
                                                    className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] transition-all hover:scale-[1.02] px-[2px] rounded py-1 mb-2 text-base font-normal text-[#000000] prevent-click">
                                                    View Providers
                                                </button>
                                            </li>
                                            <div className={`absolute ${index<3 ? 'top-3' : 'bottom-[12px]'} right-[-9px] rotate-[45deg] w-4 h-4 border-t border-r border-[#C2DCEF] bg-[#fff] z-0`}>

                                            </div> 
                                        </ul>}
                                    
                                    </div>
                                </td>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}